import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { FormikField } from '../../../Formik'
import { LoaderText } from '../../../LoaderText'
import { RADIO_SIZE, RadioGroup } from '../../../Radio'
import { ExportModalFilesList } from '../ExportModalFilesList'
import { GET_RESPONSE_LINKS_TYPE_FIELD_NAME } from '../TableExportGetResponseLinkTypeModal.constants'
import { getOptions } from '../TableExportGetResponseLinkTypeModal.utils'

import * as styles from './FormFields.module.css'

function FormFields({ fieldTitle, filesIds, isLoading }) {
  const { t } = useTranslation()

  const options = getOptions()

  return (
    <>
      {isLoading ? (
        <LoaderText />
      ) : filesIds?.length > 0 ? (
        <ExportModalFilesList items={filesIds} />
      ) : (
        <FormikField
          Component={RadioGroup}
          Field={Fragment}
          name={GET_RESPONSE_LINKS_TYPE_FIELD_NAME}
          options={options}
          radioComponentProps={{
            containerProps: { className: styles.radioContainer },
            labelProps: { className: styles.radioLabel },
            size: RADIO_SIZE.large,
          }}
          title={t(fieldTitle)}
        />
      )}
    </>
  )
}

export default FormFields
